import React, { Component } from 'react';
import GreenCentralCircle from '../GreenCentralCircle';
import OrangeCentralCircle from '../OrangeCentralCircle';
import DarkGreyCircle from '../DarkGreyCircle';
import StepperBar from '../StepperBar';
import Icon from '../../Icon';
import range from 'lodash/range';
import './styles.css';
import { formatRoute } from 'react-router-named-routes';
import { NavLink } from 'react-router-dom';
import { BUSINESSPLAN } from '../../../routes';

class Stepper extends Component {
	render() {
		const { game } = this.props;
		const submissionActive = game.lastSubmission;
		return (
			<div className="submission-stepper-layout-stepper">
				<StepperBar submissions={game.businessPlans.length} submissionActive={submissionActive} />
				{
					range(1, 4)
						.map( n => {
							if ( submissionActive >= n ) {
								return (
									<NavLink key={n} to={formatRoute( BUSINESSPLAN, { gameID : game.id, businessPlanID : game.businessPlans[n-1].submission })}>
										<DarkGreyCircle >
											<GreenCentralCircle>
												{
													game.businessPlan.submission === game.businessPlans[n-1].submission
														? <Icon icon="reviewEye" />
														: <span>{n}a</span>
												}
											</GreenCentralCircle>
										</DarkGreyCircle>
									</NavLink>
								)
							} else {
								return (
									<div key={n}>
										<OrangeCentralCircle>{n}a</OrangeCentralCircle>
									</div>
								)
							}
						})
				}
			</div>
		);
	}
}

export default Stepper;
